import { useLocation } from 'react-router-dom';
import ProductCards from './ProductCards';
import Breadcrumbs from './Breadcrumbs';
import { CartContext } from '../context/cartContext';
import { useContext } from 'react';
import { Product } from '../interface/interface';
import { generateSearchBreadcrumbs } from '../utils/generateSearchBreadCrumbs';
import { frameProductObject } from '../utils/framePrductObject';

const RenderSearchedContent = () => {
  const location = useLocation();
  const { addCart, removeCart, cart } = useContext(CartContext);

  const products = frameProductObject(
    location.state?.selectedProduct ?? [],
    cart?.line_items,
  );

  return (
    <div className="container-fullSpan">
      <Breadcrumbs
        data={[
          {
            tag: 'a',
            href: '/non-script-range',
            children: <>Home</>,
          },
          ...generateSearchBreadcrumbs(location.state),
        ]}
      />

      {!products?.length ? (
        <p className="text-center text-gray-500 py-8">
          There are no products available.
        </p>
      ) : (
        <div className="result-block-container">
          <ul className="grid grid-cols-1 gap-4 sm:grid-cols-2 sm-land:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
            {products.map((product: Product) => (
              <div key={product.id}>
                <ProductCards
                  product={product}
                  addProductToCart={addCart}
                  removeProductFromCart={removeCart}
                  isAccessories={false}
                  allowedProduct={false}
                  isGuest={false}
                />
              </div>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default RenderSearchedContent;
